import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { testosteroneQueriesStore } from "@/features/testosterone-therapy/api";
import { TherapyStep } from "@/features/testosterone-therapy/sections/";
import { Card, JarOfPillsIcon } from "@/shared/ui";

export const TestosteroneTherapyStepper = () => {
  const { data: steps, isSuccess } = useQuery(testosteroneQueriesStore.steps);

  if (isSuccess && steps.length) {
    return (
      <Card.Root className="border border-[#EDEDE7] bg-white [&>[data-slot=card-title]]:text-[#656565]">
        <Card.Title icon={JarOfPillsIcon} weight="weak">
          {t`TRT Treatment`}
        </Card.Title>

        <Card.Content className="flex flex-col gap-2">
          {steps.map((step) => (
            <TherapyStep key={step.type} {...step} />
          ))}
        </Card.Content>
      </Card.Root>
    );
  }
};
